import React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import './style/HundredPercentTransitions.css';

export class HundredPercentTransitionGroup extends React.Component {
  render() {
    const classes = ['HundredPercentTransitions__Group'];
    if (this.props.noPosition) {
      classes.push('HundredPercentTransitions__Group--NoPosition');
    }

    return (
      <div className={classes.join(' ')}>
        <TransitionGroup>{this.props.children}</TransitionGroup>
      </div>
    );
  }
}

export class HundredPercentTransition extends React.Component {
  render() {
    const { children, ...restProps } = this.props;
    return (
      <CSSTransition {...restProps}>
        <div className="HundredPercentTransitions__Content">{children}</div>
      </CSSTransition>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/ui/core/common/HundredPercentTransitions.js